export default __webpack_public_path__ + "static/media/Marketer.553b8de5.svg";